import React from 'react'
import PropertyReports from '../components/propertyReport/propertyReport';
import { hasPermission } from '../components/auth/login/Login';
import { useNavigate } from 'react-router-dom';

const PropertyReport = () => {
  const canReadReports = hasPermission("Property Report", "Report", "read");
  const navigate = useNavigate()

  if (!canReadReports) {
    navigate('/no-permission')
  }

  return (
    <PropertyReports />
  )
}

export default PropertyReport;